export const getAxiosErrorMessage = (error) => {
  // axiosのエラーレスポンスからメッセージを取得
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.error
  ) {
    return error.response.data.error
  }

  return null
}
